/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ErrorFilledIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "error-filled", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 12.5C4 7.80558 7.80558 4 12.5 4C17.1944 4 21 7.80558 21 12.5C21 17.1944 17.1944 21 12.5 21C7.80558 21 4 17.1944 4 12.5ZM13 14.5V16H12V14.5H13ZM12 9V13H13V9H12Z", fill: "currentColor" })));
}
const ForwardRef = React.forwardRef(ErrorFilledIcon);
export default ForwardRef;
//# sourceMappingURL=errorFilledIcon.js.map